import React, { useEffect, useState } from "react";
import "./style.css";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ProductCard from "../../Enums/ProductCard";
import ProductsService from "../../services/ProductsService";
import Loader from "../../common/Loader";
import NoData from "../../common/NoData";

const Category = () => {
	const [categoryData, setCategoryData] = useState({});
	const [data, setData] = useState([]);
	const [params, setParams] = useState({});
	const [hasData, setHasData] = useState(null);
	const [loading, setLoading] = useState(false);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const { t } = useTranslation();
	const location = useLocation();
	const lang = useSelector((state) => state?.lang?.lang);
	const productsService = new ProductsService();

	useEffect(() => {
		setCategoryData(location?.state);
	}, [location]);

	useEffect(() => {
		let filterParams = {};
		if (location.pathname.startsWith("/category")) {
			filterParams = {
				category_id: location?.pathname?.split("/")[2],
			};
		} else if (location.pathname === "/best-seller") {
			filterParams = {
				bestSeller: true,
			};
		}

		productsService.getList({ ...filterParams }).then((res) => {
			if (res?.status) {
				const response = res?.data?.data?.data;
				if (response?.length > 0) {
					setHasData(1);
					setData(response);
				} else {
					setData([]);
					setHasData(0);
				}
			}
		});
	}, [shouldUpdate]);

	return (
		<div className="products-page container">
			{loading && (
				<div style={{ minHeight: "90vh", display: "flex" }}>
					<Loader />
				</div>
			)}
			<div>
				{hasData === 1 && !loading && (
					<div className="categories">
						<div className="d-flex justify-content-between">
							<p className="title">
								{lang === "en" ? categoryData?.name_en : categoryData?.name_ar}
							</p>
						</div>
						<div className="row">
							{data?.map((product, index) => {
								return (
									<div
										className="col-lg-3 col-md-4 col-6 mb-3 h-100"
										key={index}>
										<ProductCard product={product} hasAddToCart={true} />
									</div>
								);
							})}
						</div>
					</div>
				)}
				{hasData === 0 && !loading && <NoData text={t(`There's no Product`)} />}
			</div>
		</div>
	);
};

export default Category;
